export const DELETE_CUSTOM_FILTER_ERROR_MESSAGE = 'Failed to delete custom filter';
